import { atom } from "recoil"

export const routeNameState = atom<string>({
  key: "atoms/routeNameState",
  default: undefined,
})
